import getDecorators from 'inversify-inject-decorators';

import { rootContainer } from '../ioc';

import { InvoiceStore } from './stores/invoice.store';
import { SavedCreditCardsStore } from 'src/payment-method/stores/saved-credit-cards.store';
import { PaymentGateway } from 'src/statement/stores/payment-gateway.store';
import { SavedPaymentMethodsStore } from 'src/payment-method/stores/saved-payment-methods.store';

export const invoiceContainer = rootContainer.createChild();
export const { lazyInject } = getDecorators(invoiceContainer);

invoiceContainer.bind(InvoiceStore).toSelf().inSingletonScope();
invoiceContainer.bind(SavedCreditCardsStore).toSelf().inSingletonScope();
invoiceContainer.bind(PaymentGateway).toSelf().inSingletonScope();
invoiceContainer.bind(SavedPaymentMethodsStore).toSelf().inSingletonScope();